import React from 'react';
import useStyles from './index.styles';
import ButtonUpgradePlan from '../ButtonUpgradePlan';
import lock from '../../assets/icons/freemium-plan/lock.svg';
import outlinedCrown from '../../assets/icons/freemium-plan/outlined-crown.svg';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Box } from '@material-ui/core';

const LimitedFreemiumPlan = ({ type = 'default', embedded = false }) => {
    const classes = useStyles();

    const DefaultLimitedType = () => {
        return (
            <div className={classes.root}>
                <div className={classes.iconContainer}>
                    <img src={lock} alt="locked" />
                </div>
                <span className={classes.title}>Función Premium</span>
                <span className={classes.description}>
                    Esta funcionalidad está disponible en planes superiores
                </span>
                <div>
                    <ButtonUpgradePlan />
                </div>
            </div>
        );
    };

    const DomainLimitedType = () => {
        return (
            <div className={classes.root}>
                <Alert
                    icon={
                        <Box display="flex" alignItems="start">
                            <img
                                src={outlinedCrown}
                                alt="lock icon"
                                style={{
                                    width: 24,
                                    height: 24,
                                    marginRight: 8,
                                }}
                            />
                        </Box>
                    }
                    severity="info"
                    className={classes.domainAlert}
                >
                    <AlertTitle className={classes.textLeft}>Dominio Personalizado</AlertTitle>
                    <div className={classes.textLeft}>
                        <span>Usa tu propio dominio como tutienda.com con el plan Pro</span>
                        <ButtonUpgradePlan />
                    </div>
                </Alert>
            </div>
        );
    };

    const ImportLimitedType = () => {
        return (
            <div className={classes.root}>
                <Alert
                    icon={
                        <Box display="flex" alignItems="start">
                            <img
                                src={outlinedCrown}
                                alt="lock icon"
                                style={{
                                    width: 24,
                                    height: 24,
                                    marginRight: 8,
                                }}
                            />
                        </Box>
                    }
                    severity="info"
                    className={classes.importAlert}
                >
                    <AlertTitle className={classes.textLeft}>
                        Sube cientos de productos desde Excel
                    </AlertTitle>
                    <div className={classes.textLeft}>
                        <ul className={classes.checkList}>
                            <li className={classes.checkListItem}>
                                Importa desde archivo Excel o CSV
                            </li>
                            <li className={classes.checkListItem}>
                                Actualiza precios e inventario masivamente
                            </li>
                            <li className={classes.checkListItem}>
                                Ahorra horas de trabajo manual
                            </li>
                        </ul>
                        <ButtonUpgradePlan />
                    </div>
                </Alert>
            </div>
        );
    };

    const PaymentMethodLimitedType = () => {
        const alert = (
            <Alert
                icon={
                    <Box display="flex" alignItems="start">
                        <img
                            src={outlinedCrown}
                            alt="lock icon"
                            style={{
                                width: 24,
                                height: 24,
                                marginRight: 8,
                            }}
                        />
                    </Box>
                }
                severity="info"
                className={classes.paymentAlert}
            >
                <AlertTitle className={classes.textLeft}>
                    Pagos en línea automáticos
                </AlertTitle>
                <div className={classes.textLeft}>
                    <ul className={classes.checkList}>
                        <li className={classes.checkListItem}>
                            PayU, Wompi, Paypal, Mercado Pago, Contra Entrega etc.
                        </li>
                        <li className={classes.checkListItem}>
                            Tarjetas de crédito y débito
                        </li>
                        <li className={classes.checkListItem}>
                            PSE y transferencias
                        </li>
                    </ul>
                    <ButtonUpgradePlan />
                </div>
            </Alert>
        );
        if (embedded) return alert;
        return <div className={classes.root}>{alert}</div>;
    };

    if (type === 'domain') return <DomainLimitedType />;
    if (type === 'payment') return <PaymentMethodLimitedType />;
    if (type === 'import') return <ImportLimitedType />;

    return <DefaultLimitedType />;
};

export default LimitedFreemiumPlan;
